/**
 * HELPER
 * Encapsula funcoes uteis para manipular a entidade preco.
 *
 * @author hjCostaBR
 */


/**
 * Calcula & retorna valores para exibir preco de uma release.
 *
 * @param {object} empPrice Configuracoes do preco.
 * @param {number} installmentsCount Numero desejado de parcelas (opcional):
 * Se for maior que a quantidade max configurada, sera automaticamente substituido pelo valor max;
 * @param {object} voucher Dados de um cupom de desconto.
 * @param {number} numberOfGuests numero de participantes.
 *
 * @return {object}
 */

export const getParsedPriceValues = (empPrice, installmentsCount, voucher = null) => {


    let discountValue = 0

    if (!empPrice)
        return {}

    // Define: Qtd de parcelas
    const maxInstallments = empPrice.maxInstallments || 1

    installmentsCount = (!!installmentsCount && installmentsCount <= maxInstallments)
        ? installmentsCount
        : maxInstallments

    // Define: Valores gerais
    const sightValue = parseFloat(empPrice.sightValue)
    const installmentInterest = parseFloat(empPrice.installmentInterest || 0)
    const interestValue = (installmentsCount > 1) ? (sightValue * installmentInterest) : 0
    const downPayment = (((installmentsCount > 1 && !!empPrice.downPayment) ? empPrice.downPayment : 0) * 1.0)
    const fullValue = (sightValue + interestValue)
    let valueToParcel = fullValue

    // Define: Desconto
    let voucherName = ""

    if (!!voucher && !!voucher.discountType && !!voucher.discountValue) {

        voucherName = voucher.name

        /*
         * Tipos de desconto de cupom:
         * 1 - Porcentagem
         * 2 - Valor em dinheiro
         */

        discountValue = (voucher.discountType == 1) ? (voucher.discountValue * fullValue) : voucher.discountValue
        valueToParcel -= discountValue
    }

    // Define: Valor da parcela
    const installmentValue = Math.round((valueToParcel * 1.0) / installmentsCount).toFixed(2)

    // Retorno
    return {sightValue, maxInstallments, installmentValue, fullValue, downPayment, discountValue, voucherName}
}


export default class SalePriceHelper {

    applyVoucherToValue(value, voucher) {
        // discountValue = (voucher.discountType == 1) ? (voucher.discountValue * value) : voucher.discountValue || 0

    }


    static getInstallmentValue(
        value,
        installmentsNumber,
        interest = 0,
        downPayment = 0
    ) {
        let finalValue = parseFloat(value)


        if (installmentsNumber === 1) {
            return finalValue
        } else {
            const installmentInterest = parseFloat(interest)
            const interestValue = finalValue * installmentInterest
            finalValue = finalValue + interestValue - downPayment
            return Math.round(finalValue / installmentsNumber).toFixed(2)
        }

    }


    //static calculateValueWithInterest(value, interest) {

    //}

}


// WEBPACK FOOTER //
// ./src/helpers/price.js